'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _coreDecorators = require('core-decorators');

var _styling = require('@rexlabs/styling');

var _tab = require('./tab');

var _tab2 = _interopRequireDefault(_tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyles = (0, _styling.StyleSheet)({
  list: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    marginBottom: '-0.3rem',
    alignItems: 'flex-start'
  },

  indicator: {
    height: '0.2rem',
    background: 'black',
    transformOrigin: '0 0'
  }
});

var TabBar = (_dec = (0, _styling.styled)(defaultStyles), _dec(_class = (0, _coreDecorators.autobind)(_class = function (_React$Component) {
  (0, _inherits3.default)(TabBar, _React$Component);

  function TabBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TabBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TabBar.__proto__ || (0, _getPrototypeOf2.default)(TabBar)).call.apply(_ref, [this].concat(args))), _this), _this._refs = {}, _this.state = {
      indicatorStyles: {}
    }, _this.throttle = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TabBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setActiveTab(this.props.activeTab, this.props, false);
      window.addEventListener('resize', this.setActiveTabThrottled);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setActiveTabThrottled);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.activeTab !== this.props.activeTab) {
        this.setActiveTab(nextProps.activeTab, nextProps, true);
      }
    }
  }, {
    key: 'setActiveTabThrottled',
    value: function setActiveTabThrottled() {
      var _this2 = this;

      clearTimeout(this.throttle);
      this.throttle = setTimeout(function () {
        return _this2.setActiveTab(_this2.props.activeTab);
      }, 200);
    }
  }, {
    key: 'setActiveTab',
    value: function setActiveTab(activeTab) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var setTransition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var s = props.styles;


      this.setState({
        indicatorStyles: (0, _extends3.default)({}, s('tabBarIndicator').style, {
          transform: 'translateX(' + (_lodash2.default.get(this._refs, activeTab + '.offsetLeft') - _lodash2.default.get(this._refs, 'parent.offsetLeft')) + 'px) scaleX(' + _lodash2.default.get(this._refs, activeTab + '.offsetWidth') / _lodash2.default.get(this._refs, 'parent.offsetWidth') + ')'
        }, setTransition ? { transition: 'transform 150ms ease-out ' } : {})
      });
    }
  }, {
    key: 'setTabRef',
    value: function setTabRef(ref, _ref2) {
      var name = _ref2.name;

      this._refs[name] = ref;
    }
  }, {
    key: 'handleTabClick',
    value: function handleTabClick(event, _ref3) {
      var name = _ref3.name;
      var _props = this.props,
          onChange = _props.onChange,
          items = _props.items,
          activeTab = _props.activeTab;

      if (onChange) {
        onChange({
          name: name,
          newIndex: items.findIndex(function (i) {
            return i.name === name;
          }),
          oldIndex: items.findIndex(function (i) {
            return i.name === activeTab;
          })
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          activeTab = _props2.activeTab,
          items = _props2.items,
          tabItemStyles = _props2.tabItemStyles,
          s = _props2.styles;
      var indicatorStyles = this.state.indicatorStyles;

      return _react2.default.createElement(
        'div',
        s('container'),
        _react2.default.createElement(
          'ul',
          (0, _extends3.default)({}, s('list'), { ref: function ref(r) {
              return _this3._refs.parent = r;
            }, role: 'tablist' }),
          items.map(function (_ref4, index) {
            var name = _ref4.name,
                label = _ref4.label,
                isDisabled = _ref4.isDisabled;

            return _react2.default.createElement(_tab2.default, {
              key: name,
              index: index,
              isDisabled: isDisabled,
              styles: tabItemStyles,
              name: name,
              label: label,
              isActive: name === activeTab || !activeTab && index === 0,
              setRef: _this3.setTabRef,
              onClick: _this3.handleTabClick
            });
          })
        ),
        _react2.default.createElement('div', (0, _extends3.default)({}, s('indicator'), { style: indicatorStyles }))
      );
    }
  }]);
  return TabBar;
}(_react2.default.Component)) || _class) || _class);
exports.default = TabBar;